<script>
    import Route, {router} from "../lib/Router/Router.svelte";
    import R, {LOADER} from "../lib/requests";
    import PageHeader from "../components/PageHeader.svelte";
    import Checkbox from "../components/controls/Checkbox.svelte";
    import Notifier from "../stores/notifier.js";

    let settings = null;

    const load = () => {
        const onSuccess = result => {
            // settings = {
            //     signup_points: result['signup_points'] || null,
            // }
            settings = result;
            console.log("SETTINGS", settings);
        }

        const onFailure = err => {
        };

        R.handle(R.settings.details, [], onSuccess, onFailure, LOADER.PAGE);
    }

    const save = () => {
        const onSuccess = result => {
            Notifier.showMessage("Settings updated");
        }

        const onFailure = err => {
        };

        R.handle(R.settings.edit, settings, onSuccess, onFailure, LOADER.PAGE);
    }

    load();
</script>

<PageHeader title="General Settings"/>

{#if settings}
    <div class="row">
        <div class="col-4">
            <div class="panel-simple panel-pad mb-4">
                <div class="form-group">
                    <label>Member Sign up Points</label>
                    <input type="number" class="form-control" bind:value="{ settings.signup_points }">
                </div>
                <div class="form-group">
                    <Checkbox label="approval is required from the receptionist at the member's checkin"
                              bind:checked={ settings.checkin_requires_approval }/>
                </div>
            </div>
            <div class="text-end">
                <button class="btn btn-primary" on:click={ save }>UPDATE</button>
            </div>
        </div>
    </div>
{/if}